<template>
    <div>
        <fusioncharts
            type="multiaxisline"
            :width="width"
            :height="height"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: [Array, Object],
                required: true,
            },
            caption: {
                type: String,
                default: ""
            },
            bgColor: {
                type: String,
                default: "#edf2f7"
            },
            width: {
                type: [Number, String],
                default: "100%"
            },
            height: {
                type: [Number, String],
                default: 270
            }
        },

        computed: {
            dataSource() {
                let chart = {
                    chart: {
                        bgColor: this.bgColor,
                        caption: this.caption,
                        showvalues: "0",
                        labeldisplay: "ROTATE",
                        rotatelabels: "1",
                        plothighlighteffect: "fadeout",
                        plottooltext: "$seriesName in $label : <b>$dataValue</b>",
                        chartLeftMargin: 50,
                        chartRightMargin: 150,
                        theme: "fusion",
                    }
                };
                
                return {...chart, ...this.data};
            }
        },
    }
</script>